/* eslint-disable */
/* @ts-ignore */
/**
 *
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 *
 * npm run graphql-codegen
 *
 * for this file to be re-created
 */
 
declare const module: {
  hot?: {
    accept: () => void;
    status: () => string;
  };
};

// @ts-ignore
const isHotReloadEnabled = typeof module !== 'undefined' && module.hot;

if (isHotReloadEnabled) {
  // @ts-ignore
  module.hot.accept();
}
import * as Types from '@/shared/types/types.generated';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { baseNotificationsApi } from '../../base-api';
export type NotificationUserInfoFragment = { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean };

export type NotificationFragment = { __typename: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } };

export type WebhookConfigurationFragment = { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, groupId?: string, name: string, description?: string, creationTimestamp?: any, creationUserId?: string, event: Types.WebhookEventsEnum, gatewayId: string, secretId?: string, destinationUrl: string, payloadMapping: string, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } };

export type ChannelSettingFragment = { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean };

export type NotificationPreferenceFragment = { __typename: 'NotificationPreferenceResponseType', userId: string, objectVersion?: number, globalSetting?: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean }, categories: Array<{ __typename: 'CategorySettingType', category: Types.NotificationCategory, setting: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } }> };

export type EntityNotificationPreferenceFragment = { __typename: 'EntityNotificationPreferenceResponseType', entityType: string, entityId: string, setting: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } };

export type CreateWebhookConfigurationMutationVariables = Types.Exact<{
  webhookConfiguration: Types.CreateWebhookConfigurationInput;
}>;


export type CreateWebhookConfigurationMutation = { __typename: 'Mutation', createWebhookConfiguration: { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type UpdateWebhookConfigurationMutationVariables = Types.Exact<{
  webhookConfigurationId: Types.Scalars['String']['input'];
  webhookConfiguration: Types.UpdateWebhookConfigurationInput;
}>;


export type UpdateWebhookConfigurationMutation = { __typename: 'Mutation', updateWebhookConfiguration: { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type DeleteWebhookConfigurationMutationVariables = Types.Exact<{
  webhookConfigurationId: Types.Scalars['String']['input'];
}>;


export type DeleteWebhookConfigurationMutation = { __typename: 'Mutation', deleteWebhookConfiguration: { __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, name: string } };

export type UpdateNotificationReadStatusMutationVariables = Types.Exact<{
  notificationId: Types.Scalars['String']['input'];
  readStatus: Types.Scalars['Boolean']['input'];
}>;


export type UpdateNotificationReadStatusMutation = { __typename: 'Mutation', updateNotificationReadStatus: { __typename: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } } };

export type UpdateMyNotificationPreferenceMutationVariables = Types.Exact<{
  input: Types.UpdateNotificationPreferenceInput;
}>;


export type UpdateMyNotificationPreferenceMutation = { __typename: 'Mutation', updateMyNotificationPreference: { __typename: 'NotificationPreferenceResponseType', userId: string, objectVersion?: number, globalSetting?: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean }, categories: Array<{ __typename: 'CategorySettingType', category: Types.NotificationCategory, setting: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } }> } };

export type SetMyEntityNotificationPreferenceMutationVariables = Types.Exact<{
  entityType: Types.Scalars['String']['input'];
  entityId: Types.Scalars['String']['input'];
  setting: Types.ChannelSettingInput;
}>;


export type SetMyEntityNotificationPreferenceMutation = { __typename: 'Mutation', setMyEntityNotificationPreference: { __typename: 'EntityNotificationPreferenceResponseType', entityType: string, entityId: string, setting: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } } };

export type RemoveMyEntityNotificationPreferenceMutationVariables = Types.Exact<{
  entityType: Types.Scalars['String']['input'];
  entityId: Types.Scalars['String']['input'];
}>;


export type RemoveMyEntityNotificationPreferenceMutation = { __typename: 'Mutation', removeMyEntityNotificationPreference: { __typename: 'EntityNotificationPreferenceResponseType', entityType: string, entityId: string, setting: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } } };

export type ReadAllNotificationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.NotificationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllNotificationsQuery = { __typename: 'Query', readAllNotifications: { __typename: 'PaginatedNotificationResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'NotificationResponseType', creationTimestamp?: any, creationUserId?: string, notificationId: string, consoleConfiguration?: { __typename: 'ConsoleNotificationResponseType', entityType?: string, entityId?: string, action: string, consoleEndpoint?: string, readStatus?: boolean, fallbackMessage?: string, status?: string } }> } };

export type UnreadNotificationsCountQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { __typename: 'Query', readAllNotifications: { __typename: 'PaginatedNotificationResponseType', itemCount: number } };

export type ReadAllWebhookConfigurationsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.WebhookConfigurationFilterInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadAllWebhookConfigurationsQuery = { __typename: 'Query', readAllWebhookConfigurations: { __typename: 'PaginatedWebhookConfigurationResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'WebhookConfigurationResponseType', webhookConfigurationId: string, groupId?: string, name: string, description?: string, creationTimestamp?: any, creationUserId?: string, event: Types.WebhookEventsEnum, gatewayId: string, secretId?: string, destinationUrl: string, payloadMapping: string, objectVersion?: number, creationUser?: { __typename: 'UserResponseType', firstName: string, lastName: string, email: string, userId: string, source: Types.UserSourceEnum, isSystemUser?: boolean } }> } };

export type ReadAllowedWebhookModelKeysQueryVariables = Types.Exact<{
  webhookEventsEnum: Types.WebhookEventsEnum;
}>;


export type ReadAllowedWebhookModelKeysQuery = { __typename: 'Query', readAllowedWebhookModelKeys: Array<string> };

export type ReadWebhookEventsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadWebhookEventsQuery = { __typename: 'Query', readWebhookEvents: Array<Types.WebhookEventsEnum> };

export type ReadNotificationCatalogueQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadNotificationCatalogueQuery = { __typename: 'Query', readNotificationCatalogue: Array<{ __typename: 'NotificationCatalogueCategoryType', category: Types.NotificationCategory, events: Array<{ __typename: 'NotificationCatalogueEventType', eventType: string, mandatory: boolean, entityType?: string, outcomeFilterable: boolean }> }> };

export type ReadMyNotificationPreferenceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ReadMyNotificationPreferenceQuery = { __typename: 'Query', readMyNotificationPreference: { __typename: 'NotificationPreferenceResponseType', userId: string, objectVersion?: number, globalSetting?: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean }, categories: Array<{ __typename: 'CategorySettingType', category: Types.NotificationCategory, setting: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } }> } };

export type ReadMyEntityNotificationPreferenceQueryVariables = Types.Exact<{
  entityType: Types.Scalars['String']['input'];
  entityId: Types.Scalars['String']['input'];
}>;


export type ReadMyEntityNotificationPreferenceQuery = { __typename: 'Query', readMyEntityNotificationPreference?: { __typename: 'EntityNotificationPreferenceResponseType', entityType: string, entityId: string, setting: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } } };

export type ReadEntityFollowersQueryVariables = Types.Exact<{
  entityType: Types.Scalars['String']['input'];
  entityId: Types.Scalars['String']['input'];
}>;


export type ReadEntityFollowersQuery = { __typename: 'Query', readEntityFollowers: { __typename: 'EntityFollowersResponseType', entityType: string, entityId: string, userIds: Array<string>, roleIds: Array<string>, groupIds: Array<string>, mutedUserIds: Array<string>, failuresOnly: boolean, entityVersion?: number } };

export type ReadMyAddedFollowQueryVariables = Types.Exact<{
  entityType: Types.Scalars['String']['input'];
  entityId: Types.Scalars['String']['input'];
}>;


export type ReadMyAddedFollowQuery = { __typename: 'Query', readMyAddedFollow: boolean };

export type ReadMyFollowedItemsQueryVariables = Types.Exact<{
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type ReadMyFollowedItemsQuery = { __typename: 'Query', readMyFollowedItems: { __typename: 'PaginatedFollowedItemResponseType', pages: number, itemCount: number, items: Array<{ __typename: 'FollowedItemResponseType', entityType: string, entityId: string, addedVia?: Types.FollowRoute, viaName?: string, addedFailuresOnly: boolean, setting?: { __typename: 'ChannelSettingType', console: boolean, email: boolean, failuresOnly: boolean } }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const NotificationFragmentDoc = new TypedDocumentString(`
    fragment Notification on NotificationResponseType {
  __typename
  creationTimestamp
  creationUserId
  notificationId
  consoleConfiguration {
    __typename
    entityType
    entityId
    action
    consoleEndpoint
    readStatus
    fallbackMessage
    status
  }
}
    `, {"fragmentName":"Notification"});
export const NotificationUserInfoFragmentDoc = new TypedDocumentString(`
    fragment NotificationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
    `, {"fragmentName":"NotificationUserInfo"});
export const WebhookConfigurationFragmentDoc = new TypedDocumentString(`
    fragment WebhookConfiguration on WebhookConfigurationResponseType {
  __typename
  webhookConfigurationId
  groupId
  name
  description
  creationTimestamp
  creationUser {
    __typename
    ...NotificationUserInfo
  }
  creationUserId
  event
  gatewayId
  secretId
  destinationUrl
  payloadMapping
  objectVersion
}
    fragment NotificationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}`, {"fragmentName":"WebhookConfiguration"});
export const ChannelSettingFragmentDoc = new TypedDocumentString(`
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}
    `, {"fragmentName":"ChannelSetting"});
export const NotificationPreferenceFragmentDoc = new TypedDocumentString(`
    fragment NotificationPreference on NotificationPreferenceResponseType {
  __typename
  userId
  objectVersion
  globalSetting {
    __typename
    ...ChannelSetting
  }
  categories {
    __typename
    category
    setting {
      __typename
      ...ChannelSetting
    }
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}`, {"fragmentName":"NotificationPreference"});
export const EntityNotificationPreferenceFragmentDoc = new TypedDocumentString(`
    fragment EntityNotificationPreference on EntityNotificationPreferenceResponseType {
  __typename
  entityType
  entityId
  setting {
    __typename
    ...ChannelSetting
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}`, {"fragmentName":"EntityNotificationPreference"});
export const CreateWebhookConfigurationDocument = new TypedDocumentString(`
    mutation CreateWebhookConfiguration($webhookConfiguration: CreateWebhookConfigurationInput!) {
  __typename
  createWebhookConfiguration(webhookConfiguration: $webhookConfiguration) {
    __typename
    webhookConfigurationId
    name
  }
}
    `);
export const UpdateWebhookConfigurationDocument = new TypedDocumentString(`
    mutation UpdateWebhookConfiguration($webhookConfigurationId: String!, $webhookConfiguration: UpdateWebhookConfigurationInput!) {
  __typename
  updateWebhookConfiguration(
    webhookConfigurationId: $webhookConfigurationId
    input: $webhookConfiguration
  ) {
    __typename
    webhookConfigurationId
    name
  }
}
    `);
export const DeleteWebhookConfigurationDocument = new TypedDocumentString(`
    mutation DeleteWebhookConfiguration($webhookConfigurationId: String!) {
  __typename
  deleteWebhookConfiguration(webhookConfigurationId: $webhookConfigurationId) {
    __typename
    webhookConfigurationId
    name
  }
}
    `);
export const UpdateNotificationReadStatusDocument = new TypedDocumentString(`
    mutation UpdateNotificationReadStatus($notificationId: String!, $readStatus: Boolean!) {
  __typename
  updateNotificationReadStatus(
    notificationId: $notificationId
    readStatus: $readStatus
  ) {
    __typename
    ...Notification
  }
}
    fragment Notification on NotificationResponseType {
  __typename
  creationTimestamp
  creationUserId
  notificationId
  consoleConfiguration {
    __typename
    entityType
    entityId
    action
    consoleEndpoint
    readStatus
    fallbackMessage
    status
  }
}`);
export const UpdateMyNotificationPreferenceDocument = new TypedDocumentString(`
    mutation UpdateMyNotificationPreference($input: UpdateNotificationPreferenceInput!) {
  __typename
  updateMyNotificationPreference(input: $input) {
    __typename
    ...NotificationPreference
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}
fragment NotificationPreference on NotificationPreferenceResponseType {
  __typename
  userId
  objectVersion
  globalSetting {
    __typename
    ...ChannelSetting
  }
  categories {
    __typename
    category
    setting {
      __typename
      ...ChannelSetting
    }
  }
}`);
export const SetMyEntityNotificationPreferenceDocument = new TypedDocumentString(`
    mutation SetMyEntityNotificationPreference($entityType: String!, $entityId: String!, $setting: ChannelSettingInput!) {
  __typename
  setMyEntityNotificationPreference(
    entityType: $entityType
    entityId: $entityId
    setting: $setting
  ) {
    __typename
    ...EntityNotificationPreference
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}
fragment EntityNotificationPreference on EntityNotificationPreferenceResponseType {
  __typename
  entityType
  entityId
  setting {
    __typename
    ...ChannelSetting
  }
}`);
export const RemoveMyEntityNotificationPreferenceDocument = new TypedDocumentString(`
    mutation RemoveMyEntityNotificationPreference($entityType: String!, $entityId: String!) {
  __typename
  removeMyEntityNotificationPreference(
    entityType: $entityType
    entityId: $entityId
  ) {
    __typename
    ...EntityNotificationPreference
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}
fragment EntityNotificationPreference on EntityNotificationPreferenceResponseType {
  __typename
  entityType
  entityId
  setting {
    __typename
    ...ChannelSetting
  }
}`);
export const ReadAllNotificationsDocument = new TypedDocumentString(`
    query ReadAllNotifications($filter: NotificationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllNotifications(filters: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...Notification
    }
  }
}
    fragment Notification on NotificationResponseType {
  __typename
  creationTimestamp
  creationUserId
  notificationId
  consoleConfiguration {
    __typename
    entityType
    entityId
    action
    consoleEndpoint
    readStatus
    fallbackMessage
    status
  }
}`);
export const UnreadNotificationsCountDocument = new TypedDocumentString(`
    query UnreadNotificationsCount {
  __typename
  readAllNotifications(filters: {consoleConfiguration: {readStatus: {ne: true}}}) {
    __typename
    itemCount
  }
}
    `);
export const ReadAllWebhookConfigurationsDocument = new TypedDocumentString(`
    query ReadAllWebhookConfigurations($filter: WebhookConfigurationFilterInput, $pagination: PaginationInput) {
  __typename
  readAllWebhookConfigurations(filter: $filter, pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      ...WebhookConfiguration
    }
  }
}
    fragment NotificationUserInfo on UserResponseType {
  __typename
  firstName
  lastName
  email
  userId
  source
  isSystemUser
}
fragment WebhookConfiguration on WebhookConfigurationResponseType {
  __typename
  webhookConfigurationId
  groupId
  name
  description
  creationTimestamp
  creationUser {
    __typename
    ...NotificationUserInfo
  }
  creationUserId
  event
  gatewayId
  secretId
  destinationUrl
  payloadMapping
  objectVersion
}`);
export const ReadAllowedWebhookModelKeysDocument = new TypedDocumentString(`
    query ReadAllowedWebhookModelKeys($webhookEventsEnum: WebhookEventsEnum!) {
  __typename
  readAllowedWebhookModelKeys(webhookEventsEnum: $webhookEventsEnum)
}
    `);
export const ReadWebhookEventsDocument = new TypedDocumentString(`
    query ReadWebhookEvents {
  __typename
  readWebhookEvents
}
    `);
export const ReadNotificationCatalogueDocument = new TypedDocumentString(`
    query ReadNotificationCatalogue {
  __typename
  readNotificationCatalogue {
    __typename
    category
    events {
      __typename
      eventType
      mandatory
      entityType
      outcomeFilterable
    }
  }
}
    `);
export const ReadMyNotificationPreferenceDocument = new TypedDocumentString(`
    query ReadMyNotificationPreference {
  __typename
  readMyNotificationPreference {
    __typename
    ...NotificationPreference
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}
fragment NotificationPreference on NotificationPreferenceResponseType {
  __typename
  userId
  objectVersion
  globalSetting {
    __typename
    ...ChannelSetting
  }
  categories {
    __typename
    category
    setting {
      __typename
      ...ChannelSetting
    }
  }
}`);
export const ReadMyEntityNotificationPreferenceDocument = new TypedDocumentString(`
    query ReadMyEntityNotificationPreference($entityType: String!, $entityId: String!) {
  __typename
  readMyEntityNotificationPreference(entityType: $entityType, entityId: $entityId) {
    __typename
    ...EntityNotificationPreference
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}
fragment EntityNotificationPreference on EntityNotificationPreferenceResponseType {
  __typename
  entityType
  entityId
  setting {
    __typename
    ...ChannelSetting
  }
}`);
export const ReadEntityFollowersDocument = new TypedDocumentString(`
    query ReadEntityFollowers($entityType: String!, $entityId: String!) {
  __typename
  readEntityFollowers(entityType: $entityType, entityId: $entityId) {
    __typename
    entityType
    entityId
    userIds
    roleIds
    groupIds
    mutedUserIds
    failuresOnly
    entityVersion
  }
}
    `);
export const ReadMyAddedFollowDocument = new TypedDocumentString(`
    query ReadMyAddedFollow($entityType: String!, $entityId: String!) {
  __typename
  readMyAddedFollow(entityType: $entityType, entityId: $entityId)
}
    `);
export const ReadMyFollowedItemsDocument = new TypedDocumentString(`
    query ReadMyFollowedItems($pagination: PaginationInput) {
  __typename
  readMyFollowedItems(pagination: $pagination) {
    __typename
    pages
    itemCount
    items {
      __typename
      entityType
      entityId
      setting {
        __typename
        ...ChannelSetting
      }
      addedVia
      viaName
      addedFailuresOnly
    }
  }
}
    fragment ChannelSetting on ChannelSettingType {
  __typename
  console
  email
  failuresOnly
}`);

const injectedRtkApi = baseNotificationsApi.injectEndpoints({
  overrideExisting: isHotReloadEnabled && module.hot?.status() === "apply",
  endpoints: (build) => ({
    CreateWebhookConfiguration: build.mutation<Types.CreateWebhookConfigurationMutation, Types.CreateWebhookConfigurationMutationVariables>({
      query: (variables) => ({ document: CreateWebhookConfigurationDocument as unknown as string, variables })
    }),
    UpdateWebhookConfiguration: build.mutation<Types.UpdateWebhookConfigurationMutation, Types.UpdateWebhookConfigurationMutationVariables>({
      query: (variables) => ({ document: UpdateWebhookConfigurationDocument as unknown as string, variables })
    }),
    DeleteWebhookConfiguration: build.mutation<Types.DeleteWebhookConfigurationMutation, Types.DeleteWebhookConfigurationMutationVariables>({
      query: (variables) => ({ document: DeleteWebhookConfigurationDocument as unknown as string, variables })
    }),
    UpdateNotificationReadStatus: build.mutation<Types.UpdateNotificationReadStatusMutation, Types.UpdateNotificationReadStatusMutationVariables>({
      query: (variables) => ({ document: UpdateNotificationReadStatusDocument as unknown as string, variables })
    }),
    UpdateMyNotificationPreference: build.mutation<Types.UpdateMyNotificationPreferenceMutation, Types.UpdateMyNotificationPreferenceMutationVariables>({
      query: (variables) => ({ document: UpdateMyNotificationPreferenceDocument as unknown as string, variables })
    }),
    SetMyEntityNotificationPreference: build.mutation<Types.SetMyEntityNotificationPreferenceMutation, Types.SetMyEntityNotificationPreferenceMutationVariables>({
      query: (variables) => ({ document: SetMyEntityNotificationPreferenceDocument as unknown as string, variables })
    }),
    RemoveMyEntityNotificationPreference: build.mutation<Types.RemoveMyEntityNotificationPreferenceMutation, Types.RemoveMyEntityNotificationPreferenceMutationVariables>({
      query: (variables) => ({ document: RemoveMyEntityNotificationPreferenceDocument as unknown as string, variables })
    }),
    ReadAllNotifications: build.query<Types.ReadAllNotificationsQuery, Types.ReadAllNotificationsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllNotificationsDocument as unknown as string, variables })
    }),
    UnreadNotificationsCount: build.query<Types.UnreadNotificationsCountQuery, Types.UnreadNotificationsCountQueryVariables | void>({
      query: (variables) => ({ document: UnreadNotificationsCountDocument as unknown as string, variables })
    }),
    ReadAllWebhookConfigurations: build.query<Types.ReadAllWebhookConfigurationsQuery, Types.ReadAllWebhookConfigurationsQueryVariables | void>({
      query: (variables) => ({ document: ReadAllWebhookConfigurationsDocument as unknown as string, variables })
    }),
    ReadAllowedWebhookModelKeys: build.query<Types.ReadAllowedWebhookModelKeysQuery, Types.ReadAllowedWebhookModelKeysQueryVariables>({
      query: (variables) => ({ document: ReadAllowedWebhookModelKeysDocument as unknown as string, variables })
    }),
    ReadWebhookEvents: build.query<Types.ReadWebhookEventsQuery, Types.ReadWebhookEventsQueryVariables | void>({
      query: (variables) => ({ document: ReadWebhookEventsDocument as unknown as string, variables })
    }),
    ReadNotificationCatalogue: build.query<Types.ReadNotificationCatalogueQuery, Types.ReadNotificationCatalogueQueryVariables | void>({
      query: (variables) => ({ document: ReadNotificationCatalogueDocument as unknown as string, variables })
    }),
    ReadMyNotificationPreference: build.query<Types.ReadMyNotificationPreferenceQuery, Types.ReadMyNotificationPreferenceQueryVariables | void>({
      query: (variables) => ({ document: ReadMyNotificationPreferenceDocument as unknown as string, variables })
    }),
    ReadMyEntityNotificationPreference: build.query<Types.ReadMyEntityNotificationPreferenceQuery, Types.ReadMyEntityNotificationPreferenceQueryVariables>({
      query: (variables) => ({ document: ReadMyEntityNotificationPreferenceDocument as unknown as string, variables })
    }),
    ReadEntityFollowers: build.query<Types.ReadEntityFollowersQuery, Types.ReadEntityFollowersQueryVariables>({
      query: (variables) => ({ document: ReadEntityFollowersDocument as unknown as string, variables })
    }),
    ReadMyAddedFollow: build.query<Types.ReadMyAddedFollowQuery, Types.ReadMyAddedFollowQueryVariables>({
      query: (variables) => ({ document: ReadMyAddedFollowDocument as unknown as string, variables })
    }),
    ReadMyFollowedItems: build.query<Types.ReadMyFollowedItemsQuery, Types.ReadMyFollowedItemsQueryVariables | void>({
      query: (variables) => ({ document: ReadMyFollowedItemsDocument as unknown as string, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateWebhookConfigurationMutation, useUpdateWebhookConfigurationMutation, useDeleteWebhookConfigurationMutation, useUpdateNotificationReadStatusMutation, useUpdateMyNotificationPreferenceMutation, useSetMyEntityNotificationPreferenceMutation, useRemoveMyEntityNotificationPreferenceMutation, useReadAllNotificationsQuery, useLazyReadAllNotificationsQuery, useUnreadNotificationsCountQuery, useLazyUnreadNotificationsCountQuery, useReadAllWebhookConfigurationsQuery, useLazyReadAllWebhookConfigurationsQuery, useReadAllowedWebhookModelKeysQuery, useLazyReadAllowedWebhookModelKeysQuery, useReadWebhookEventsQuery, useLazyReadWebhookEventsQuery, useReadNotificationCatalogueQuery, useLazyReadNotificationCatalogueQuery, useReadMyNotificationPreferenceQuery, useLazyReadMyNotificationPreferenceQuery, useReadMyEntityNotificationPreferenceQuery, useLazyReadMyEntityNotificationPreferenceQuery, useReadEntityFollowersQuery, useLazyReadEntityFollowersQuery, useReadMyAddedFollowQuery, useLazyReadMyAddedFollowQuery, useReadMyFollowedItemsQuery, useLazyReadMyFollowedItemsQuery } = injectedRtkApi;

